<!--
 * @Description:  BM 页脚
 * @Author: zwcong
 * @Date: 2025-07-22 15:32:38
 * @LastEditors: zwcong
 * @LastEditTime: 2025-08-06 11:49:48
-->
<template>
  <div v-if="showFooter" class="footer">
    <div class="wrapper font-medium">
      <div class="module-wrapper">
        <div class="module-left">
          <div class="module-item brand">
            <div class="logo" :class="`logo-${$store.state.locale}`">
              <img v-lazy-load v-lazy-load :data-src="logoUrl" :alt="$t('seo.common.logoDescription')" :title="$t('common.websiteName')" :height="isMobile ? 37 : 50" width="auto" loading="lazy">
            </div>
          </div>
          <div class="module-item flex-column">
            <label>Sign up for our Newsletter.</label>
            <div class="email-box">
              <input v-model="email" maxlength="50" type="email" :placeholder="placeholder">
              <button class="submit-btn" @click="handleSubmit" />
            </div>
          </div>
          <div class="module-item">
            <div v-for="follow in follows" :key="follow.icon" class="follow">
              <label>{{ follow.title }}</label>
              <a v-if="follow.link" class="link" rel="noopener" :href="follow.link" target="_blank">
                <div class="icon" :class="follow.icon" />
              </a>
              <div v-else class="icon" :class="follow.icon" />
            </div>
          </div>
        </div>
        <div class="module-right">
          <div v-for="(item, index) in schoolList" :key="index" class="module-item">
            <label>{{ item.title }}</label>
            <div v-for="link in item.links" :key="link.icon" class="item-link">
              <i class="icon" :class="link.icon" />
              <a v-if="link.type === 'email'" class="link" rel="noopener" :href="`mailto:${link.text}`">
                {{ link.text }}
              </a>
              <a v-else-if="link.type === 'tel'" class="link" rel="noopener" :href="`tel:${link.text}`">
                {{ link.text }}
              </a>
              <template v-else>
                {{ link.text }}
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from './mixin.js';

export default {
  mixins: [mixin],
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 796;
    },
  },
}
</script>
<style lang="scss" scoped>
.footer {
  font-size: 14px;
  line-height: 18px;
  color: #fff;
  background: #9173ff;
  font-family: 'Roboto-Flex';

  .wrapper {
    padding: 76px;

    .module-wrapper {
      display: flex;
      justify-content: space-between;

      .module-left {
        display: flex;
        flex-direction: column;
        gap: 45px;

        .module-item {
          display: flex;
          gap: 30px;

          &.flex-column {
            flex-direction: column;
          }

          .follow {
            display: flex;
            align-items: center;
            gap: 20px;

            .link {
              &:hover {
                opacity: 0.8;
              }
            }

            label {
              width: 100px;
              line-height: 31px;
            }

            .icon {
              width: 54px;
              height: 54px;
              background-size: 100%;
              background-repeat: no-repeat;

              &.icon-facebook3 {
                background-image: url('~assets/images/common/icon-facebook.png');
              }
            }
          }

          label {
            font-weight: 500;
            font-size: 20px;
          }

          .email-box {
            //width: 100%;
            width: 421px;
            max-width: 100%; // 保证小屏幕时不会超过屏幕宽
            height: 69px;
            background: #fff;
            border-radius: 50px 50px 50px 50px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding: 15px 9px 15px 34px;

            input {
              flex: 1;
              width: 100%;
              height: 100%;
              border: none;
              font-size: 20px;
              color: #999;

              &:focus,
              &:active {
                outline: none;
                border: none;
              }
            }

            .submit-btn {
              width: 54px;
              height: 54px;
              border-radius: 50%;
              background-color: #9173ff;
              border: none;
              background-image: url('~assets/images/common/icon-post.png');
              background-size: 100%;
              background-repeat: no-repeat;
              cursor: pointer;

              &:hover {
                opacity: 0.8;
              }
            }
          }
        }
      }

      .module-right {
        display: flex;
        flex-direction: column;

        .module-item {
          display: flex;
          flex-direction: column;
          gap: 15px;
          border-bottom: 1px solid #fff;
          padding: 30px;
          padding-left: 0;

          &:is(:first-child) {
            padding-top: 10px;
          }

          &:last-child {
            border-bottom: none;
          }

          label {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 10px;
          }

          .item-link {
            font-size: 20px;
            font-weight: 500;
            display: flex;
            gap: 6px;
            align-items: center;

            .link {
              color: #fff;

              &:hover {
                opacity: 0.8;
              }
            }

            .icon {
              width: 23px;
              height: 23px;
              background-size: 100%;
              background-repeat: no-repeat;

              &.icon-address {
                background-image: url('~assets/images/common/icon-address.png');
              }

              &.icon-phone {
                background-image: url('~assets/images/common/icon-phone.png');
              }

              &.icon-email {
                background-image: url('~assets/images/common/icon-email.png');
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 796px) {
  .footer {
    font-size: 4.267vw;

    .wrapper {
      padding: 11.467vw 6.933vw;
      width: 100%;

      .module-wrapper {
        flex-direction: column;
        justify-content: normal;

        .module-left {
          gap: 4.8vw;

          .module-item {
            gap: 5.333vw;

            &.flex-column {
              margin-top: 2.667vw;
            }

            .follow {
              label {
                width: 21.333vw;
                line-height: 6.4vw;
              }

              .icon {
                width: 11.2vw;
                height: 11.2vw;
              }
            }

            label {
              line-height: 6.4vw;
              font-size: 4.267vw;
            }

            .email-box {
              height: 10.933vw;
              padding: 1.333vw 1.067vw 1.333vw 5.333vw;
              width: 100%;

              input {
                font-size: 4.267vw;
              }

              .submit-btn {
                width: 9.067vw;
                height: 9.067vw;
              }
            }
          }
        }

        .module-right {
          margin-top: 5.867vw;

          .module-item {
            border-top: 0.267vw solid #fff;
            border-bottom: 0;
            padding: 6.667vw 0;

            &:is(:first-child) {
              padding-top: 6.667vw;
            }

            &:last-child {
              padding-bottom: 0;
            }

            label {
              font-size: 4.267vw;
              margin-bottom: 1.6vw;
            }

            .item-link {
              font-size: 3.2vw;
            }

            .icon {
              width: 3.733vw;
              height: 3.733vw;
            }
          }
        }
      }
    }
  }
}
</style>
